import { Button } from "react-bootstrap";
import CustomModal from "./../customModal/CustomModal";
import deleteusermodalimge from "../../assets/images/delete-user-modal-image.svg";
import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface DeleteConfModelProps {
  showModal: boolean;
  toggleModal: () => void;
  deleteAction: () => void;
  modelName: string;
  recordName?: string;
  isDeletePermitted?: boolean;
  enableCaptcha?: boolean;
  recaptchaSiteKey?: string;
  onCaptchaVerified?: (token: string) => Promise<void>;
}

export const DeleteConfModel: React.FC<DeleteConfModelProps> = ({
  showModal,
  toggleModal,
  deleteAction,
  modelName,
  recordName,
  isDeletePermitted = true,
  enableCaptcha = false,
  recaptchaSiteKey,
  onCaptchaVerified,
}) => {
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const handleClose = () => {
    setCaptchaToken(null);
    recaptchaRef.current?.reset();
    toggleModal();
  };

  const handleDelete = async () => {
    if (enableCaptcha && captchaToken && onCaptchaVerified) {
      try {
        await onCaptchaVerified(captchaToken);
        deleteAction();
      } catch {
        recaptchaRef.current?.reset();
        setCaptchaToken(null);
      }
    } else {
      deleteAction();
    }
  };

  const isDeleteDisabled = enableCaptcha ? !captchaToken || !isDeletePermitted : !isDeletePermitted;

  return (
    <>
      {showModal && (
        <CustomModal
          title=""
          content={
            <>
              <div className="modal--content--wrapper">
                <img src={deleteusermodalimge} alt="" />
                <h5>
                  Are you sure you want to <br />
                  delete this {modelName}{" "}
                  <span className="action-item-name" title={recordName || ""}>
                    '{recordName || ""}'
                  </span>
                  ?
                </h5>
              </div>
              {enableCaptcha && recaptchaSiteKey && (
                <div className="recaptcha-wrapper">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={recaptchaSiteKey}
                    onChange={(token) => setCaptchaToken(token)}
                    onExpired={() => setCaptchaToken(null)}
                    onErrored={() => setCaptchaToken(null)}
                  />
                </div>
              )}
              <div className="modal--action--btn--wrapper">
                <Button
                  type="button"
                  variant="outline-primary"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button type="button" variant="primary" onClick={handleDelete} disabled={isDeleteDisabled}>
                  Delete
                </Button>
              </div>
            </>
          }
          onClose={handleClose}
        />
      )}
    </>
  );
};
